import React, { useEffect, useState } from 'react';
import PropertiesHeaderSection from './PropertiesSection';
import PropertyCard from '../../../Components/card/PropertyCard';
import useFetch from '../../../hooks/useFetch';
import { getAllProperties, getTrendingProperties, increasePropertyVisits } from '../../../services/propertyService';
import { API_BASE_URL } from '../../../Utils/constants';
import LoadingComponent from '../../../Components/LoadingComponent/loading';
import { formatNumberUtil } from '../../../Utils/localStorageUtils';
import { useSelector } from 'react-redux';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import useUserLocation from '../../../hooks/useUserLocation';
import useCurrentLocation from '../../../hooks/useCurrentLocation';

const PropertiesSection = () => {

  const {goTo} = useCustomNavigate()

  const { city, locality, isLoading } = useCurrentLocation();
  console.log("Current Location:", city, locality);

  const currentLocationDetails = useSelector((state) => state?.counter?.location)
  

  // Set city name, default to "Jaipur"
  const cityName = currentLocationDetails?.city || "Jaipur";

  // Encode location details for query params
  const locationData = encodeURIComponent(
    JSON.stringify({
      city: currentLocationDetails.city || "",
      state: currentLocationDetails.state || "",
      country: currentLocationDetails.country || "",
    })
  );




  const formatDate = (dateString) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    return `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;
  };


    // Fetch trending properties based on city and locality
    const { data: propertiesData,loading, error,} = useFetch(() =>
      getTrendingProperties({
        city: city,
        locality: locality,
        page: 1,
        limit: 10,
      }),
      [city,locality]
    );



  if (loading) {
    return <LoadingComponent />; // Display a loading spinner or message
  }

  if (error) {
    return <div>Error: {error.message}</div>; // Display error message
  }







    // ✅ Function to increase visits (created only once)
    const handlePropertyClick = async (propertyId) => {
      try {
          await increasePropertyVisits(propertyId);
          console.log(`Visits increased for property: ${propertyId}`);
      } catch (error) {
          console.error("Failed to update visit count:", error);
      }

      goTo(`/propertydetail/${propertyId}`); // ✅ Navigate after API call
  };



  return (
    <div className=''>
      <PropertiesHeaderSection headerTitle='Trending Properties Near By You'
        navigateTo={`/allproperties/${cityName}?location=${locationData}`} // ✅ Updated navigation link
      />

      <div className='px-4 md:px-8 flex overflow-x-auto space-x-4 py-2' style={{ scrollbarWidth: 'none' }}>
        {propertiesData?.properties?.length > 0 ? (
           propertiesData.properties.map((property) => {
            const {
              createdAt,
              _id,
              mediaFiles = [],
              basicDetails,
              pricingAndOthers,
              aboutProperty,
              locationDetails,
              status,
            } = property || {};

            return (
              <PropertyCard
                key={_id}
                propertyId={_id}
                imageUrl={
                  mediaFiles?.[0]?.fileName
                    ? `${API_BASE_URL}${mediaFiles[0].fileName}`
                    : "https://www.ikonmarket.com/assets/images/marketing-articles/luxury-home.jpg"
                }
                title={
                  basicDetails?.additionalOption?.value
                    ? `${basicDetails.additionalOption.value} BHK Flat`
                    : "No Title"
                }
                price={`₹${formatNumberUtil(
                  pricingAndOthers?.OwnershipPriceDetails?.expectedPrice
                ) || "5 Lac"
                  }`}
                size={`${aboutProperty?.areaDetails?.buildupArea || "1000"} sqft`}
                location={
                  locationDetails?.city && locationDetails?.searchLocation
                    ? `${locationDetails.city}, ${locationDetails.searchLocation}`
                    : "Location not provided"
                }
                status={aboutProperty?.availabilityStatus || "Ready To Move"}
                photosCount={mediaFiles?.length || 0}
                date={formatDate(createdAt)}
                visits={property?.visits || 0} // ✅ Show visit count
                onClick={handlePropertyClick} // ✅ Pass function as prop
              />
            );
          })) : (
          <div>No properties available</div> // Display message if properties2 is empty
        )}
      </div>
    </div>
  );
}

export default PropertiesSection;
